import { render, staticRenderFns } from "./TransactionCreate.vue?vue&type=template&id=5d4272c8"
import script from "../../controllers/transaction/transaction-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/transaction/transaction-create.js?vue&type=script&lang=js&external"
import style0 from "./TransactionCreate.vue?vue&type=style&index=0&id=5d4272c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports